// extracted by mini-css-extract-plugin
module.exports = {"person":"person-component-module--person--1dxmx"};